import { createRoutine } from 'redux-saga-routines';
import { action } from 'typesafe-actions';
import { Props } from './index';

const ACTIVATE = 'STOCK_LANDING/ACTIVATE';
const DEACTIVATE = 'STOCK_LANDING/DEACTIVATE';

const lifecycle = {
  activate: (props: Props) => action(ACTIVATE, props),
  deactivate: () => action(DEACTIVATE),
};

const routine = createRoutine('STOCK-DEPOSIT/SUBMIT');

export { ACTIVATE, DEACTIVATE, lifecycle, routine };
